
import { Controller } from "stimulus";

export default class extends Controller {
    static targets = ["purchaserFirstNameInput", "purchaserFirstNameError", "purchaserLastNameInput", "purchaserLastNameError"];

    connect() {
        this.purchaserFirstNameInputTarget.value = this.purchaserFirstName;
        this.purchaserLastNameInputTarget.value = this.purchaserLastName;
    }

    get purchaserFirstName() {
        return this.data.get("purchaser-first-name");
    }

    set purchaserFirstName(name) {
        this.data.set("purchaser-first-name", name);
        this.publishPurchaserNameUpdatedEvent("first-name-updated", name);
    }

    get purchaserLastName() {
        return this.data.get("purchaser-last-name");
    }

    set purchaserLastName(name) {
        this.data.set("purchaser-last-name", name);
        this.publishPurchaserNameUpdatedEvent("last-name-updated", name);
    }

    purchaserFirstNameInputUpdated() {
        let input = this.purchaserFirstNameInputTarget.value.trim();
        this.purchaserFirstName = this.validateName(input, this.purchaserFirstNameErrorTarget) ? input : "";
    }

    purchaserLastNameInputUpdated() {
        let input = this.purchaserLastNameInputTarget.value.trim();
        this.purchaserLastName = this.validateName(input, this.purchaserLastNameErrorTarget) ? input : "";
    }

    publishPurchaserNameUpdatedEvent(nameEvent, name) {
        const event = document.createEvent("CustomEvent");
        event.initCustomEvent(nameEvent, true, true, null);
        event.name = name;
        this.element.dispatchEvent(event);
    }

    validateName(name, errorTarget) {
        if (name == "") {
            this.showError(errorTarget, this.data.get('required-error'));
            return false;
        } else if (name.length > 50) {
            this.showError(errorTarget, this.data.get('max-character-error'));
            return false;
        } else if (this.hasEmojis(name)) {
            this.showError(errorTarget, 'invalid-name-error');
        } else {
            this.hideError(errorTarget);
            return true;
        }
    }

    hasEmojis(string) {
        var reHasEmojis = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/
        return reHasEmojis.test(string);
    }

    showError(errorTarget, errorMessage) {
        errorTarget.innerHTML = errorMessage;
        errorTarget.classList.toggle('hidden', false);
    }

    hideError(errorTarget) {
        errorTarget.innerHTML = "";
        errorTarget.classList.toggle('hidden', true);
    }
}
